"use strict";

exports.__esModule = true;
var _SlidingTimeline = require("./SlidingTimeline");
Object.keys(_SlidingTimeline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SlidingTimeline[key]) return;
  exports[key] = _SlidingTimeline[key];
});